module.exports = __webpack_public_path__ + "img/JL03.4ca185eb.jpg";